/* BETALUMINA_PUSH_FRONTEND_V1 */
import axios from "axios";

const API_BASE_URL =
  process.env.REACT_APP_API_URL || "https://interventi.synology.me:5050";
const SERVICE_WORKER_URL = "/betalumina-push-sw.js";

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const rawData = window.atob(base64);
  return Uint8Array.from([...rawData].map((char) => char.charCodeAt(0)));
}

export function isPushSupported() {
  return typeof window !== "undefined" &&
    "serviceWorker" in navigator &&
    "PushManager" in window &&
    "Notification" in window;
}

async function registerPushServiceWorker() {
  const registration = await navigator.serviceWorker.register(
    SERVICE_WORKER_URL, { scope: "/" }
  );
  await navigator.serviceWorker.ready;
  return registration;
}

async function fetchPublicKey() {
  const response = await axios.get(`${API_BASE_URL}/api/push/public-key`, {
    withCredentials: true,
  });
  const publicKey = String(response?.data?.publicKey || "");
  if (!publicKey) throw new Error("Chiave pubblica push non disponibile");
  return publicKey;
}

async function syncSubscription(subscription) {
  const token = localStorage.getItem("token");
  if (!token) throw new Error("Sessione non disponibile");
  await axios.post(
    `${API_BASE_URL}/api/push/subscribe`,
    subscription.toJSON(),
    { headers: { Authorization: `Bearer ${token}` }, withCredentials: true }
  );
}

export async function ensurePushSubscription({ askPermission = false } = {}) {
  if (!isPushSupported()) return { status: "unsupported", subscription: null };

  let permission = Notification.permission;
  if (permission === "default" && askPermission) {
    permission = await Notification.requestPermission();
  }

  if (permission === "denied") return { status: "denied", subscription: null };
  if (permission !== "granted") return { status: "available", subscription: null };

  const registration = await registerPushServiceWorker();
  let subscription = await registration.pushManager.getSubscription();

  if (!subscription) {
    const publicKey = await fetchPublicKey();
    subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(publicKey),
    });
  }

  await syncSubscription(subscription);
  return { status: "enabled", subscription };
}
